export default __webpack_public_path__ + "static/media/susesi6.edc410a5.jpg";